import script from "./HeaderDewarmsteweek.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderDewarmsteweek.vue?vue&type=script&setup=true&lang=js"

import "./HeaderDewarmsteweek.vue?vue&type=style&index=0&id=f39c26f8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f39c26f8"]])

export default __exports__